export default __webpack_public_path__ + "a250f2d5e000f329fc565cc92a790e64.svg";